import useLanguage from '~/client/hooks/useLanguage';
import useSite from '~/client/hooks/useSite';
import {
  useSubmitSupportFormMutation,
  SubmitSupportFormMutationVariables,
} from './graphql/SubmitSupportFormMutation.generated';
import type FormValues from '../FormValues';

const useSubmitSupportEmail = () => {
  const { site } = useSite();
  const { code } = useLanguage();

  const [submitSupportForm, { loading, error }] =
    useSubmitSupportFormMutation();

  const handleSubmitForm = async (values: FormValues, files?: string[]) => {
    const variables: SubmitSupportFormMutationVariables = {
      site,
      language: code,
      topic: values.topic,
      email: values.email,
      message: values.message,
      files,
    };

    const { data } = await submitSupportForm({ variables });
    return data?.knowYourCustomerSubmitSupportForm;
  };

  return { handleSubmitForm, loading, error };
};

export default useSubmitSupportEmail;
